import apiClient from "../api/apiClient";
import authService from "./authService";
import { assertSafePayload } from "../utils/inputValidation";

// Generic API Wrapper using centralized apiClient (which handles 401 token refresh mutex)
async function request(endpoint, method = "GET", body = null, useAuth = true) {
  if (body) {
    assertSafePayload(body, endpoint);
  }

  try {
    const response = await apiClient({
      url: endpoint,
      method,
      data: body || undefined,
    });

    return response.data;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
}

// Hospital APIs
export function createHospital(data) {
  return request("/hospital", "POST", data);
}

export function getHospitals() {
  return request("/hospital", "GET");
}

// Patients APIs
export function getAllPatients() {
  return request("/api/patients/all", "GET");
}

export function getPatientById(id) {
  return request(`/api/patients/${id}`, "GET");
}

export function createPatient(data) {
  return request("/api/patients", "POST", data);
}

export function updatePatient(id, data) {
  return request(`/api/patients/${id}`, "PUT", data);
}

export function deletePatient(id) {
  return request(`/api/patients/${id}`, "DELETE");
}

// Vitals APIs
export function saveVitals(data) {
  return request("/api/vitals/save", "POST", data);
}

export function getLatestVitals(abhaNumber) {
  return request(`/api/vitals/latest/${abhaNumber}`, "GET");
}

// Prescriptions APIs
export function savePrescription(data) {
  return request("/api/prescriptions/save", "POST", data);
}

// SOAP Notes APIs
export function saveSoapNotes(data) {
  return request("/api/soap-notes/save", "POST", data);
}

// Lab Reports APIs
export function saveLabReport(data) {
  if (!authService.isAuthenticated()) {
    throw new Error("Session expired. Please login again.");
  }
  return request("/api/lab-reports/upsert", "POST", data, true);
}

const apiService = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  patch: (url, data, config) => apiClient.patch(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
  createHospital,
  getHospitals,
  getAllPatients,
  getPatientById,
  createPatient,
  updatePatient,
  deletePatient,
  saveVitals,
  getLatestVitals,
  savePrescription,
  saveSoapNotes,
  saveLabReport,
};

export default apiService;
